import clsx from "clsx";
import { FC, ReactNode } from "react";

interface NavbarButtonProps {
  icon: ReactNode;
  title: string;
  isActive?: boolean;
}

const NavbarButton: FC<NavbarButtonProps> = ({ icon, title, isActive }) => {
  return (
    <div
      className={clsx([
        "active-red-500 flex flex-row items-center gap-1 border-r-4 p-4 text-center text-xs hover:text-blue-600 md:flex-col",
        {
          "bg-blue-50": isActive,
          "border-blue-600": isActive,
          "text-blue-600": isActive,
          "border-transparent": !isActive,
          "text-gray-500": !isActive,
        },
      ])}
    >
      {icon}
      <span>{title}</span>
    </div>
  );
};

export default NavbarButton;
